module.exports = __webpack_public_path__ + "static/media/contratomutuo.7bf7cb46.svg";